import styled, { css } from 'styled-components';

export const StyledSearchBox = styled.div`
    z-index: 1;
    background: #ffffff;

    box-shadow: 0 24px 48px -8px rgba(0, 0, 0, 0.8);
    border-radius: 6px;
    width: 100%;
    max-width: 670px;

    > *:first-child {
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
    }
    > *:last-child {
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
    }
`;

interface SearchBoxInnerProps {
    readonly brand?: boolean;
    readonly muted?: boolean;
    readonly stretch?: boolean;
    readonly isMap?: boolean;
    readonly extraTop?: boolean;
    readonly extraBottom?: boolean;
    readonly textAlign?: 'left' | 'right' | 'center';
    readonly align?: 'flex-start' | 'flex-end' | 'center';
}

export const StyledSearchBoxInner = styled.div<SearchBoxInnerProps>`
    ${({ theme, brand, muted, stretch, textAlign, align, isMap, extraTop, extraBottom }) => css`
        padding: 24px;
        position: relative;
        display: flex;
        flex-direction: column;
        background-color: ${theme.colors.white};
        color: ${theme.colors.copy};
        box-sizing: border-box;

        @media (min-width: ${theme.breakpoints.sm}px) {
            ${isMap
                ? css`
                      padding: 24px 48px 48px 48px;
                  `
                : css`
                      padding: 48px;
                  `}
        }

        ${extraBottom &&
        css`
            padding-bottom: 48px;
        `}
        ${extraTop &&
        css`
            padding-top: 48px;
        `}
        ${muted &&
        css`
            background-color: ${theme.colors.grey};
            color: ${theme.colors.copy};
        `}
        ${brand &&
        css`
            background-color: ${theme.colors.brand};
            color: ${theme.colors.white};
        `}
        ${stretch &&
        css`
            flex-grow: 1;
        `}
        ${textAlign &&
        css`
            text-align: ${textAlign};
        `}
        ${align &&
        css`
            justify-content: ${textAlign};
        `}
    `}
`;
